import React from 'react'
import { Tag as AntTag } from 'antd';

function Tag({ tag }) {
    return (
        <AntTag>{tag}</AntTag>
    )
}

export default Tag